<template>
  <div class="no-bill-container">
    <img src="@/assets/img/no-bill@2x.png" />
    <div class="tip">
      {{ msg }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'BillList',
  props: {
    msg: {
      type: String,
      default: '暂无未出账单',
    },
  },
};
</script>
<style lang="scss" scoped>
.no-bill-container {
  img {
    width: 442px;
    height: 328px;
    margin: 233px auto 10px;
  }
  .tip {
    font-size: 28px;
    color: rgba(0,0,0,0.42);
  }
}
</style>
